
/** 登录注册渠道归因信息。 */
export interface Channels {
    /** 登录入口来源。 */
    from?: string
    /** 登录入口页面。 */
    from_page?: string
    /** 注册渠道来源。 */
    channel_source?: string
    /** 注册活动类型。 */
    activity_type?: string
    /** 邀请者用户 ID。 */
    inviter_id?: string
    /** 邀请业务来源代码。 */
    invitation_code?: string
    /** 分享邀请的传播媒介。 */
    media_type?: 'email' | 'link'
    /** 是否使用匿名登录。 */
    anonymousLogin?: boolean
}

export type RegisterMethod = 'google' | 'microsoft' | 'linkedin' | 'email'
export interface LoginOptions {
    channels?: Channels
    withoutClose?: boolean
    silence?: boolean
    emailRedirectUri?: string
    onClickRegister?: (method: RegisterMethod) => void
}

interface LoginSDK {
    openLoginDialog: (options?: LoginOptions) => Promise<void>
    initSDK: () => Promise<void>
}
let loginSDKPromise: Promise<LoginSDK>;


export function getEurekaLoginSDK(): Promise<LoginSDK> {
    return loginSDKPromise ??= import(/* @vite-ignore */ `${import.meta.env.VITE_CDN_BASE_URL}/login/login.sdk.es.no-cache.js`);
}
